import path from 'path';
import { getValidDomains } from './getValidDomains.js';

export function getCertificatePaths(options: { domain?: string | string[]; cwd: string }): {
  certFolderPath: string;
  certPath: string;
  keyPath: string;
} {
  const { domain, cwd } = options;
  const domains = getValidDomains(domain);
  const primaryDomain = domains?.[0];

  if (!primaryDomain) {
    throw new Error('Must provide at least one domain in "domain" option to get certificate paths.');
  }

  const certFolderPath = path.join(cwd, 'node_modules', '.cache', 'cloudpack', 'cert');

  return {
    certFolderPath,
    certPath: path.join(certFolderPath, `${primaryDomain}.crt`),
    keyPath: path.join(certFolderPath, `${primaryDomain}.key`),
  };
}
